// Generated from Web static copy outside Analyze. Keep source strings as English keys.
export const generatedStaticZh: Record<string, string> = {
  "-day free trial": "天免费试用",
  "— a dedicated server that runs the NavOption API, analyze service, collector, PostgreSQL, and Redis.": "— 运行 NavOption API、分析服务、收集器、PostgreSQL 和 Redis 的专用服务器。",
  "— be more conservative or step aside on new positions.": "——更加保守或放弃新的持仓。",
  "— content delivery, edge caching, DDoS protection.": "— 内容交付、边缘缓存、DDoS 防护。",
  "— payments, subscription management, billing portal.": "— 支付、订阅管理、计费门户。",
  "— premium capped on the upside, the stock’s entire downside on the bad side. See the diagrams below:": "- 权利金在上行方面受到限制，而股票的整体下行则在坏方面。参见下图：",
  "— Sign in with Apple, App Store, StoreKit (subscription verification), Apple Push Notification service (APNs).": "— 使用Apple、App Store、StoreKit（订阅验证）、Apple推送通知服务（APNs）登录。",
  "— Sign in with Google (OpenID Connect identity verification only).": "— 使用Google登录（仅OpenID Connect身份验证）。",
  "— upstream U.S. equity and options market data.": "— 美国股票和期权市场上游数据。",
  ", and the IV evaluator is still accumulating snapshot history. The IV card will appear automatically as soon as NavOption captures enough half-hourly snapshots during US market hours.": "，并且 IV 评估器仍在累积快照历史记录。一旦 NavOption 在美国市场时段捕获足够的半小时快照，IV 卡就会自动出现。",
  ", including the Limited Use requirements.": "，包括限制使用要求。",
  ", mock-log a put assignment to see how cost basis is displayed.": "，模拟记录看跌被指派以查看成本基础如何显示。",
  ", not by ticket count. A high-beta name takes a smaller position than a low-beta utility, even if the strike is the same.": "，不按合约数计算。即使行权价相同，高贝塔系数标的的持仓也比低贝塔系数公用事业公司的持仓要小。",
  ", on a name you’d hate to lose for cheap. IV is elevated (more premium), but the stock can rip past the strike on a beat, and you give up the upside.": "，一个你不想轻易失去的名字。 IV 被抬高（权利金更高），但股票可能会瞬间突破行权价，而您则放弃上涨空间。",
  ", on any open trade click \"Roll Candidates\". The list is sorted by net credit.": "，在任何未平仓交易中点击“移仓候选”。该列表按净收入排序。",
  ", open the Stripe billing portal, and choose Cancel.": "，打开 Stripe 计费门户，然后选择取消。",
  ", so cancellation takes effect": "，所以取消生效",
  ", the opposite is true — IV typically": "，反之亦然 — 通常为 IV",
  ", with a strike near or below the current price. The call holder will exercise early to capture the dividend, and your": "，行权价接近或低于当前价格。看涨期权持有人将提前行权以获取股息，并且您的",
  ": a 15% headline wheel yield in a top tax bracket nets ~9% after federal+state. A 6% qualified dividend on the same stock nets ~5%. The wheel often still wins on after-tax basis — but the gap is much smaller than the headline yield suggests, especially in a taxable account.": "：最高税级的总体收益率为 15%，仅次于联邦+州，净收益率约为 9%。同一股票的 6% 合格股息净值约为 5%。在税后基础上，轮转策略通常仍然会获胜——但差距比总体收益率所显示的要小得多，尤其是在应税账户中。",
  ": a deal between two people that covers": "：两个人之间的交易，涵盖",
  ": AAPL trades at $220 on May 1. You sell the AAPL Jun 6 $200 put for $2.50.": "：AAPL 5 月 1 日的交易价格为 220 美元。您以 2.50 美元的价格卖出 6 月 6 日 200 美元的 AAPL 看跌。",
  ": after a sharp": ": 尖锐之后",
  ": aggressive in-the-money covered calls can suspend the 61-day holding period required for qualified dividend treatment, converting a 15-20% tax rate into ordinary rates. If dividend income is a meaningful part of your thesis, keep CCs out-of-the-money.": "：激进的实值备兑看涨可以暂停合格股息处理所需的 61 天持有期，将 15-20% 的税率转换为普通税率。如果股息收入是你投资逻辑的一个有意义的部分，那么就让 CC 处于价外状态。",
  ": approximate probability the option finishes in-the-money. −0.20 put ≈ 20% chance of assignment. (Approximation — breaks down for high-skew names.)": "：期权最终处于价内状态的近似概率。 −0.20 put ≈ 20% 的被指派机会。 （近似值 - 对于高偏差标的会崩溃。）",
  ": between Friday close and Monday open the stock can move. If a CEO resignation or a guidance cut hits Sunday night, you may be assigned shares already trading well below your strike. The premium you collected does not insure against this — it’s the same downside you’d have as a buy-and-hold investor.": "：在周五收盘和周一开盘之间，股票可能会波动。如果周日晚上首席执行官辞职或指导意见下调，你可能会被指派到已经远低于你的行权价价格的股票。您收取的权利金并不能保证这一点——这与您作为买入并持有的投资者所面临的负面影响相同。",
  ": bid-ask spreads widen 5–10× in a vol spike. The \"tight spread\" filter you used last week disappears exactly when you need to roll.": "：成交量峰值时，买卖价差扩大 5-10 倍。当你需要移仓时，你上周使用的“紧密传播”过滤器就会消失。",
  ": Buy 100 shares for $22,000.": "：以 22,000 美元购买 100 股。",
  ": closer-to-the-money = more premium but more chance of assignment (your shares get called away). Further out-of-the-money = less premium, more chance of keeping the shares and selling another call next month.": "：更接近实值=更多的权利金，但更多的转让机会（你的股票被收回）。进一步的价外=权利金减少，保留股票并在下个月再次出售看涨的机会更大。",
  ": contracts traded today / total contracts open. Both should be at least ~100 to avoid getting stuck in a wide spread.": "：今日交易合约数/未平仓合约总数。两者都应至少约为 100，以避免陷入广泛的价差。",
  ": daily premium decay. Your paycheck as a seller. Accelerates as expiry approaches.": "：每日权利金衰减。您作为卖家的薪水。随着到期日的临近而加速。",
  ": if you take a loss on a stock then sell a \"substantially identical\" position (including puts on the same underlying) within 30 days, the loss is disallowed and added to the basis of the replacement. Brokers often don’t track this perfectly across options + shares. Keep your own log.": "：如果您在股票上遭受损失，然后在 30 天内卖出“基本相同”的持仓（包括相同标的的看跌），则该损失将被禁止并添加到替换的基础上。券商通常不会在期权+股票之间完美地跟踪这一点。保留自己的日志。",
  ": in crashes, individual stock correlations spike toward 1.0. Your 8-name diversified book becomes one trade. Sector spread doesn’t fully save you.": "：在崩盘中，个股相关性飙升至 1.0。你的 8 个名字的多样化组合成为一项交易。行业传播并不能完全拯救你。",
  ": index options (SPX, NDX, RUT, VIX) get 60% long-term / 40% short-term treatment and are marked to market at year-end. Equity options (SPY, AAPL, MSFT) are": "：指数期权（SPX、NDX、RUT、VIX）获得 60% 长期/40% 短期待遇，并在年底按市价计价。股票期权（SPY、AAPL、MSFT）是",
  ": it happens automatically over the weekend. Friday close: your put is ITM. Monday morning: cash is gone, shares are in your account, and your cost basis is the strike": "：它会在周末自动发生。周五收盘：您的看跌是 ITM。周一早上：现金没了，股票在你的账户里，你的成本基础是行权价",
  ": open short puts go red on the screen when VIX spikes, even before the stock moves. This is mark-to-market pain that triggers panic-close behavior. Plan for it psychologically.": "：当 VIX 飙升时，甚至在股票变动之前，未平仓看跌会在屏幕上变红。这是按市值计价的痛苦，会引发恐慌平仓行为。从心理上做好计划。",
  ": pick a strike above your": "：选择高于您的行权价",
  ": rare on puts. More common on": "：看跌很少见。更常见于",
  ": rolling forever on a stock you no longer want to own. Discipline is to set,": "：永远移仓你不再想拥有的股票。纪律是要定下的，",
  ": Sell one $200 cash-secured put. Collect $250 premium. Set aside $20,000 in cash.": "：卖出一份价值 200 美元的现金担保看跌。收取 250 美元权利金。预留20,000美元现金。",
  ": selling deep-ITM calls against an appreciated long position can trigger constructive-sale treatment — the IRS treats it as if you closed the stock at a gain. Avoid deep-ITM CCs on long-held appreciated stock.": "：针对升值的多头持仓出售深度 ITM 看涨可能会引发建设性出售待遇——美国国税局将其视为您以盈利方式平仓股票。避免对长期持有的升值股票进行深度 ITM CC。",
  ": stocks gap through strikes overnight. The premium does not insure against this.": "：隔夜股市因行权价而跳空。权利金并不能保证这一点。",
  ": the buyer has the right to": ": 买家有权利",
  ": the buyer says \"I want my side of the deal.\" Only the buyer can choose this.": "：买家说“我想要我一方的交易。”只有买家可以选择这个。",
  ": the calendar date the deal ends. After this date the contract is over.": "：交易结束的日历日期。在此日期之后，合约就结束了。",
  ": the cash the buyer pays the seller, upfront, today. Quoted per share — so a premium of $2.50 means the seller receives $2.50 × 100 =": "：买方今天向卖方预付的现金。以每股报价 — 因此 2.50 美元的权利金意味着卖方收到 2.50 美元 × 100 =",
  ": the price the deal is locked at. Example: a $200 strike call on AAPL is a deal about buying/selling AAPL at $200/share.": "：交易锁定的价格。示例：AAPL 的 200 美元行使权看涨是以 200 美元/股买入/卖出 AAPL 的交易。",
  ": the seller has to honor the deal because the buyer exercised. Cash and shares move automatically — usually overnight Friday into Monday.": "：由于买方行使了权利，卖方必须履行交易。现金和股票会自动移动——通常是从周五到周一隔夜。",
  ": what others will pay you / what you’d pay / a fair midpoint. Limit orders go in near the mid.": "：别人会付给你多少钱/你会付多少钱/一个公平的中点。限价订单在接近中期时进入。",
  ". Educational research only.": "。仅限教育研究。",
  ". For web purchases, email us and we will work with you within Stripe’s policies.": "。对于网络购买，请给我们发送电子邮件，我们将在 Stripe 的政策范围内与您合作。",
  ". Here is the cashflow you’re committing to:": "。这是您承诺的现金流：",
  ". If VIX spikes from 15 to 30 mid-trade, your screen will turn red even if the stock hasn’t moved through your strike. That’s a mark-to-market loss, not a realized one — but it’s why a calm week feels like ten before a vol spike.": "。如果 VIX 在交易中期从 15 飙升至 30，即使该股票尚未经过您的行权价，您的屏幕也会变成红色。这是按市值计算的损失，而不是实际损失，但这就是为什么平静的一周感觉就像成交量飙升前的十周。",
  ". Premium might look juicy because IV stays elevated, but you risk capping upside on a name with real momentum.": "。权利金可能看起来很诱人，因为 IV 保持较高水平，但你可能会面临着限制具有真正动力的标的的上涨空间的风险。",
  ". Reported on Schedule D / Form 8949. Taxed at ordinary-income rates but not classified as ordinary income for purposes like NIIT or state treatment.": "。按附表 D/表格 8949 报告。按普通收入税率征税，但出于 NIIT 或国家待遇等目的不归类为普通收入。",
  ". We may suspend or terminate access if we reasonably believe you have violated these Terms or if continued operation poses legal, security, or commercial risk.": "。如果我们有理由相信您违反了这些条款或继续运营会带来法律、安全或商业风险，我们可能会暂停或终止访问。",
  ". We will respond within 30 days. EU/UK (GDPR), California (CCPA/CPRA), and China (PIPL) residents have additional statutory rights that we will honor as required by law.": "。我们将在 30 天内回复。欧盟/英国 (GDPR)、加利福尼亚州 (CCPA/CPRA) 和中国 (PIPL) 居民拥有其他法定权利，我们将根据法律要求尊重这些权利。",
  ". You don’t know whether you’ll be assigned until Monday morning. The contract may or may not be exercised. Treat this as a coin flip and don’t plan around it.": "。直到周一早上你才知道自己是否会被指派。合约可以履行也可以不履行。把这当作抛硬币一样，不要围绕它制定计划。",
  "· IV": "· IV",
  "· the detector runs after each RTH close, so pre-market / weekend / holiday windows show the most recent set.": "· 探测器在每次 RTH 收盘后运行，因此盘前 / 周末 / 节假日窗口会显示最近一组结果。",
  "· Updated": "· 更新",
  "“Buy low.”": "“低价买入。”",
  "“Hold through anything.”": "“凡事都要坚持。”",
  "“Reinvest dividends.”": "“股息再投资。”",
  "\"Run the wheel on": "“运行轮转策略：",
  "(and the actual reason it works)": "（以及它起作用的实际原因）",
  "(assignment strike minus premium). Selling below cost basis locks in a loss if assigned away.": "（转让行权价减去权利金）。如果转让，低于成本基础的销售将导致损失。",
  "(cache stale — origin may be lagging)": "（缓存陈旧 - 来源可能滞后）",
  "(covered call) leg of the wheel. You own 100 shares at the strike. Time to sell calls against them.": "（备兑看涨）轮转策略环节。您在行权价时拥有 100 股。是时候针对这些股票卖出看涨了。",
  "(end of your current billing period).": "（当前计费周期结束）。",
  "(implied volatility): the market’s guess about how much the stock will move, annualized.": "（隐含波动率）：市场对股票年化幅度的猜测。",
  "(own the stock, P/L tracks the price). As an option seller your payoff is": "（拥有股票，P/L 跟踪价格）。作为期权卖家，您的回报是",
  "(realized volatility): how much the stock has actually been moving. When IV > RV by a clear margin, options are richly priced — good for sellers.": "（已实现波动率）：股票实际变动了多少。当 IV > RV 明显高于 RV 时，期权价格昂贵——对卖家有利。",
  "(test)": "（测试）",
  "(yes, this one matters): how much your open position changes in value when IV moves. Wheel traders are": "（是的，这一点很重要）：当 IV 移动时，您的未平仓持仓价值会发生多少变化。轮转交易者是",
  "(you collect more premium than you paid to close). Use it when the trade is going against you and you’re not ready to accept assignment.": "（您收取的权利金多于您支付的成交费用）。当交易对你不利并且你还没有准备好接受被指派时使用它。",
  "% · back": "％ · 后退",
  "% vs price": "% 与价格",
  "→ \"Conservative CSP\" preset. Click the first row. The strike, premium and APY are already computed.": "→“保守CSP”预设。单击第一行。行权价、权利金和 APY 已计算。",
  "→ put expires worthless → you keep every penny of premium → repeat next month.": "→ 看跌到期毫无价值 → 您保留每一分权利金 → 下个月重复。",
  "→ this is": "→ 这是",
  "→ you’re assigned → cash leaves, 100 shares arrive at the strike price.": "→ 你被指派 → 现金离开，100 股到达行权价格。",
  "+ a little": "+ 一点",
  "+ Add position": "+ 添加持仓",
  "+ Watchlist": "+ 关注列表",
  "+$250 — or you buy at $197.50 effective": "+ 250 美元 — 或者您以 197.50 美元购买有效",
  "+$250 (you missed the rally)": "+$250（你错过了上涨）",
  "+50% credit on the short option → take profit, free up capital.": "+ 50% 空头期权信用 → 获利了结，释放资本。",
  "= one oversized trade.": "= 一笔超大交易。",
  "= prior same-ticker alerts that moved favorably.": "= 先前走势良好的相同股票警报。",
  "−$1,750 (assigned, holding loss)": "−$1,750（被指派，持有损失）",
  "−200% loss vs premium → close. No exceptions.": "−200% 损失 vs 权利金 → 平仓。没有例外。",
  "≤ 14 DTE": "≤ 14 DTE",
  "✓ In Watchlist": "✓ 在关注列表中",
  "$/sh": "美元/股",
  "$170 P": "170 美元",
  "$180 (down)": "$180（下）",
  "$200 P": "200 美元",
  "$220 (flat)": "$220（平价）",
  "$240 (up)": "$240（起）",
  "$240 P": "240 美元",
  "$420 P": "420 美元",
  "$540 P": "540 美元",
  "1. Acceptance of Terms": "1. 接受条款",
  "1. Information We Collect": "1. 我们收集的信息",
  "10. Changes to this Policy": "10. 本政策的变更",
  "10. Termination": "10. 终止",
  "100 sh @ $200": "100先令@200美元",
  "100 shares": "100股",
  "11. Contact": "11. 联系方式",
  "11. Disclaimer of Warranties": "11. 免责声明",
  "12. Limitation of Liability": "12. 责任限制",
  "1256 — they’re straight short-term. If you scale up, consider moving size to SPX for the tax efficiency.": "1256——他们是直接短期的。如果扩大规模，请考虑将大小移至 SPX 以提高税收效率。",
  "13. Indemnification": "13. 赔偿",
  "14. Governing Law and Disputes": "14. 适用法律和争议",
  "15. Contact": "15. 联系方式",
  "2 outcomes": "2 个结果",
  "2. Eligibility": "2. 资格",
  "2. How We Use Information": "2. 我们如何使用信息",
  "3 unusual strikes": "3次异常行权价",
  "3. Third-Party Services": "3. 第三方服务",
  "3. Your Account": "3. 您的帐户",
  "30–45 DTE": "30–45 DTE",
  "30d / 90d / 180d IV side-by-side": "30d / 90d / 180d IV 并排",
  "4. Sharing": "4. 分享",
  "4. Subscriptions and Billing": "4. 订阅和计费",
  "4.2× baseline": "4.2×基线",
  "5. Data Retention": "5. 数据保留",
  "5. Refunds": "5. 退款",
  "50% take-profit. Pre-committed max loss. The wheel is a system, not stubbornness.": "50%止盈。预先承诺的最大损失。轮转策略是一个系统，而不是固执。",
  "52W range": "52W范围",
  "6. Acceptable Use": "6. 可接受的使用",
  "6. Your Rights": "6. 您的权利",
  "7. Children": "7. 儿童",
  "7. Market Data and Educational Use": "7. 市场数据和教育用途",
  "72% confidence": "72% 置信度",
  "8. Intellectual Property": "8. 知识产权",
  "8. Push Notifications": "8. 推送通知",
  "9. Security": "9. 安全",
  "9. Your Content": "9. 您的内容",
  "90-day total on $20K collateral · ~2.6% / ~10.3% APY": "$20K 担保金的 90 天总收益 · 约 2.6% / 约 10.3% APY",
  "A \"why it matters\" line on each item.": "每个项目上都有一行“为什么重要”。",
  "A 16-character panel argues both sides of any trade.": "一个由 16 个字符组成的小组对任何交易的双方进行争论。",
  "A randomly generated install ID, app version, OS version, push notification token (if you grant permission), and crash diagnostics.": "随机生成的安装 ID、应用程序版本、操作系统版本、推送通知令牌（如果您授予权限）和崩溃诊断。",
  "A second opinion before you click buy": "点击“购买”之前的第二意见",
  "A single CSP at most ~10% of your account is the same discipline as not putting 50% in one stock.": "单个 CSP 最多占您账户的 10%，与不将 50% 的资金投入一只股票是同样的原则。",
  "A single CSP shouldn’t risk more than ~10% of your account at the strike. That’s the floor.": "单个 CSP 在行权价时所冒的风险不应超过您账户的 10%。那是底线。",
  "A structured curriculum, written for US-stock investors at any level. Five chapters, ten modules, every term defined on first use.": "为任何级别的美国股票投资者编写的结构化课程。五章，十个模块，每个术语均在首次使用时定义。",
  "A typical 90-day wheel cycle on AAPL.": "AAPL 上一个典型的 90 天轮转周期。",
  "A widely-cited Reddit post from r/Optionswheel describes one experienced wheel trader’s March 2020 experience. They ran the wheel across ~8 stocks, kept 50% cash, and survived the crash with a moderate YTD drawdown that recovered within the year.": "r/Optionswheel 的一篇被广泛引用的 Reddit 帖子描述了一位经验丰富的轮转策略交易员 2020 年 3 月的经历。他们经营了大约 8 只股票，保留了 50% 的现金，并在崩盘中幸存下来，年初至今略有回撤，并在一年内恢复。",
  "AAPL, NVDA, TSLA": "AAPL, NVDA, TSLA",
  "above your cost → collect premium.": "高于您的成本 → 收取权利金。",
  "Access record": "访问记录",
  "Active alerts": "活动警报",
  "Actual move": "实际移动",
  "Add Hunt": "添加狩猎",
  "Add or remove from any stock page in one tap.": "一键添加或从任何库存页面删除。",
  "added · -": "添加·-",
  "Added to watchlist": "已添加至关注列表",
  "Admin grant": "管理补助金",
  "After the close": "收盘后",
  "After-tax reality check": "税后现实检查",
  "All core research workflows are currently available to signed-in users: scanner, earnings, news, full Analyze panels, watchlist, and position tracking.": "所有核心研究工作流程目前均可供登录用户使用：扫描器、财报、新闻、完整的 Analyze 面板、观察列表和持仓跟踪。",
  "All sectors": "所有行业",
  "All Signals": "所有信号",
  "and add from there.": "并从那里添加。",
  "Annual yield, distance to assignment, days to expiration, fill-ability.": "年收益率、被指派距离、到期天数、填充能力。",
  "App Store": "App Store",
  "App Store purchases are subject to Apple’s refund process at": "App Store 购买受 Apple 退款流程约束，入口为",
  "App Store record": "App Store 记录",
  "Apple Inc.": "Apple Inc.",
  "Applying…": "正在申请…",
  "Approximate PoP for a sold option.": "已售期权的近似 PoP。",
  "APY = (premium / strike) × (365 / DTE)": "APY =（权利金 / 行权价）×（365 / DTE）",
  "APY = annualized headline yield (premium ÷ collateral × 365/DTE) assuming the put expires worthless. Your": "APY = 年化名义收益率（权利金 ÷ 担保金 × 365/DTE），假设看跌到期归零。你的",
  "APY 38% · Score 78": "APY 38% · 评分 78",
  "APY%": "APY%",
  "Assignment + event aware": "被指派+事件感知",
  "Assignment is a feature, not a bug. Don’t sell puts on stocks you don’t want to own.": "被指派是一个功能，而不是一个错误。不要出售您不想拥有的股票的看跌。",
  "Asymmetric payoff: small wins many times, occasional big loss. Discipline matters more than instinct.": "不对称收益：多次小额盈利，偶尔大额亏损。纪律比本能更重要。",
  "At cap — close one or upgrade to Pro to add more.": "已达上限，请关闭一个或升级到 Pro 后添加更多。",
  "At month end, log: total P&L, premium collected, realized losses, mark-to-market open. Bucket the P&L into theta (time decay you captured), delta (stock moves against / for you), vega (vol changes). Without attribution you can’t tell luck from skill, and you can’t improve.": "月末，记录：总损益、收取的权利金、已实现的损失、按市值计价的开仓金额。将损益表分为 theta（您捕捉到的时间衰减）、Delta（股票走势对您不利/有利）、Vega（波动率变化）。没有归因，你就无法区分运气和技能，也无法进步。",
  "Attribution — the habit that turns retail into pro": "归因——将零售变成专业的习惯",
  "Average daily option volume over the last 7 days.": "过去 7 天的平均每日期权交易量。",
  "Average move": "平均移动",
  "Avg chain IV": "平均期权链 IV",
  "Avg daily decay ≈ premium / DTE": "平均每日衰减 ≈ 权利金 / DTE",
  "Avg IV": "平均 IV",
  "Bear Case": "空头观点",
  "Bearish hedge": "看跌对冲",
  "Bearish hedge — possible protective flow": "看跌对冲——可能的保护流",
  "Before any strategy, here is the entire vocabulary you need. Read this once, refer back as much as you want.": "在制定任何策略之前，这里是您需要的全部词汇。读一遍这篇文章，你想参考多少就参考多少。",
  "Before learning the mechanics, see how the wheel actually compares to just buying the stock. Here is AAPL trading at $220, with two strategies for the next 35 days:": "在学习机制之前，先看看轮转策略实际上与只购买股票相比如何。这是 AAPL 的交易价格为 220 美元，未来 35 天有两种策略：",
  "Before the open": "开盘前",
  "Beginner-friendly presets: Conservative · High-yield · Covered call.": "适合初学者的预设：保守·高收益·备兑看涨。",
  "below the current price → collect premium.": "低于当前价格 → 收取权利金。",
  "Best APY": "最佳 APY",
  "Best Cash-Secured Put": "最佳现金担保看跌",
  "Best Covered Call": "最佳备兑看涨",
  "between −0.15 and −0.30.": "介于-0.15 和-0.30 之间。",
  "Bid / Ask / Mid": "买价/卖价/中价",
  "Block only": "仅阻止",
  "Block without edge": "无边块",
  "Boring routine. Risk-budgeted sizing. 50% cash buffer until you have your own math. Monthly attribution.": "无聊的日常。风险预算规模。 50% 的现金缓冲，直到你有自己的数学。每月归因。",
  "Both strategies are exposed to the same downside — but the wheel keeps the premium as a small cushion.": "这两种策略都面临着同样的不利因素——但轮转策略将权利金作为一个小缓冲。",
  "Bottom track: AAPL drops 3% past your strike. You’re assigned at $200, sell a $210 call for another $180, but you’re mark-to-market down ~$570 on the shares. This is the trade-off you’re accepting when you sell the put. Honest stress-test scenarios in": "下方路径：AAPL 跌破你的行权价 3%。你在 $200 被指派，再卖出 $210 看涨收取 $180，但股票按市价计已亏约 $570。这就是卖出看跌时接受的取舍。更坦诚的压力测试场景见",
  "BUY · 72% conf": "买入 · 72% 确认",
  "By Contract": "按合约",
  "By Symbol": "按代码",
  "Call vs put volume ratio": "看涨与看跌交易量比率",
  "Call-side pressure": "呼叫端压力",
  "Calls + puts": "看涨+看跌",
  "Cancel a web subscription.": "取消网络订阅。",
  "Cancel an iOS subscription.": "取消iOS订阅。",
  "Capital needed to keep wheel positions running simultaneously, including a buffer for slippage and roll cash.": "让多个轮转持仓同时运行所需的资金，包括滑点和移仓现金缓冲。",
  "Capital required to run the wheel across multiple symbols.": "跨多个代码运行轮转策略所需的资金。",
  "Cash and shares move overnight. You don’t pick when. Plan for it before you open the trade.": "现金和股票隔夜流动。你不选择什么时候。在开始交易之前就做好计划。",
  "Cash you must set aside to sell a cash-secured put.": "卖出现金担保看跌时必须预留的现金。",
  "Cash-Secured Put": "现金担保看跌",
  "CC APY": "CC APY",
  "CC IV": "CC IV",
  "CC next": "CC 接下来",
  "CC Score": "CC 分数",
  "CC Strike": "CC 行权价",
  "Chain depth": "链条深度",
  "chain-tab is-active": "链期权卡处于活动状态",
  "Charles Schwab": "Charles Schwab",
  "Chart blocked — open in TradingView": "图表被阻止 — 在 TradingView 中打开",
  "Chart Watcher": "图表观察者",
  "Chasing risk": "追逐风险",
  "Check Module 9 before you decide.": "在做出决定之前请先查看第 9 单元。",
  "Cleaner follow-through": "更更清晰的后续工作",
  "Cleaner history": "更清晰历史",
  "Clear Filters": "清除过滤器",
  "Click any ticker to jump to its stock page.": "单击任何代码即可跳转至其股票页面。",
  "Cloudflare, Inc.": "Cloudflare, Inc.",
  "Coming up": "即将推出",
  "Compare annualized covered-call yield to the stock's dividend yield to see how much you're getting paid for the cap on upside.": "将年化备兑看涨收益率与股票的股息收益率进行比较，看看您从上涨上限中获得了多少报酬。",
  "Compare CC premium yield to dividend yield.": "比较 CC 权利金收益率和股息收益率。",
  "Confirm cancellation": "确认取消",
  "Conservative CSP": "保守 CSP",
  "Constructive sale (§1259)": "推定销售（§1259）",
  "contracts · page": "合约·页",
  "contracts = floor( (portfolio × risk%) / (strike × 100) )": "合约数 = floor((组合资金 × 风险%) / (行权价 × 100))",
  "Contrarian Watch — OOS-validated short signal on hedge-cluster": "逆势观察 — OOS 验证的对冲集群空头信号",
  "contribution to portfolio vega and beta-adjusted dollars": "对投资组合 Vega 和 Beta 调整美元的贡献",
  "Convert delta to an approximate assignment probability.": "将 delta 转换为近似被指派概率。",
  "Correlation breakdown": "相关性分析",
  "cost basis": "成本基础",
  "Cost basis ($)": "成本基础（美元）",
  "Cost basis = strike − premium": "成本基础=行权价-权利金",
  "Covered Call": "备兑看涨",
  "CSP APY": "CSP APY",
  "CSP APY 30D": "CSP APY 30D",
  "CSP Cash Calculator": "CSP 现金计算器",
  "CSP IV": "CSP IV",
  "CSP next": "CSP 接下来",
  "CSP Score": "CSP 分数",
  "CSP Strike": "CSP 行权价",
  "Curated catalysts and headlines from the same feed iOS uses.": "来自 iOS 使用的相同提要的精选催化剂和头条新闻。",
  "Custom UOA alerts": "自定义 UOA 提醒",
  "d to expiry. Candidates ranked by score.": "d 至到期日。考生按成绩排名。",
  "d window": "d 窗口",
  "Day 0": "第 0 天",
  "Day 30": "第 30 天",
  "Day 60": "第 60 天",
  "Day 90": "第 90 天",
  "days, sorted by date. Implied move comes from the ATM straddle of the soonest expiry on/after the report.": "天，按日期排序。隐含的变动来自于报告当天/之后最早到期的 ATM 跨式组合。",
  "Defense playbook": "防守手册",
  "Deleting your NavOption account does not automatically cancel an external subscription that may have been created before paid plans were paused.": "删除您的 NavOption 帐户不会自动取消在付费计划暂停之前可能创建的外部订阅。",
  "Depending on where you live, you may have rights to access, correct, export, or delete your personal data, to object to or restrict processing, and to withdraw consent. To exercise these rights, email": "根据您居住的地方，您可能有权访问、更正、导出或删除您的个人数据，反对或限制处理，以及撤回同意。要行使这些权利，请发送电子邮件",
  "Disclaimer: general information, not tax advice. Talk to a CPA.": "免责声明：一般信息，并非税务建议。与注册会计师交谈。",
  "Diversified across uncorrelated industries, not just sectors.": "多元化跨越不相关的行业，而不仅仅是板块。",
  "Diversify by risk contribution, not by sector count.": "按风险贡献而非板块数量进行多元化。",
  "Do I need to connect a brokerage?": "我需要连接券商吗？",
  "Doesn’t apply to short-dated options. What matters is implied volatility, time decay, and assignment probability.": "不适用于短期期权。重要的是隐含波动率、时间衰减和被指派概率。",
  "Don’t run 8 CSPs on tech names. Spread across sectors.": "不要在技术标的上运行 8 个 CSP。分布于各个行业。",
  "Drives what shows in News and Earnings Watch.": "推动新闻和财报观察中的显示内容。",
  "DTE and gap % update from live quotes. Synced with iOS.": "DTE 和跳空幅度% 会根据实时报价更新，并与 iOS 同步。",
  "Early assignment": "早期被指派",
  "Earnings + IV": "财报 + IV",
  "Earnings Analyst": "财报分析师",
  "EARNINGS CALENDAR": "财报日历",
  "Earnings dates 3–30 days ahead, with the trade context you need.": "提前 3 至 30 天的财报日期，以及您需要的交易背景。",
  "Earnings dates, unusual options flow (big institutional bets), and the news that actually matters for your symbols — on one page.": "财报日期、不寻常的期权流（大型机构押注）以及对您的代码真正重要的新闻 - 在一页上。",
  "Earnings is coming ·": "财报将近 ·",
  "Earnings this week": "本周财报",
  "Earnings Watch": "财报观察",
  "Earnings week": "财报周",
  "Effective cost basis when a CSP gets assigned.": "CSP 被指派后的有效成本基础。",
  "Eight tools, one wheel-trading workflow.": "八个工具，一套轮转交易流程。",
  "Elevated IV": "IV 偏高",
  "End trial now": "立即结束试用",
  "Error:": "错误：",
  "Est EPS": "预计每股收益",
  "Est Rev": "预计收入",
  "Estimate daily theta as a % of the credit collected.": "将每日 theta 估计为所收集信用的百分比。",
  "Estimated EPS, estimated revenue, year-over-year growth.": "预计每股收益、预计收入、同比增长。",
  "EV = P(win) × avg_win − (1 − P(win)) × avg_loss": "EV = P(win) × avg_win − (1 − P(win)) × avg_loss",
  "Every day until Jun 6: a small amount of time value bleeds out of the contract — that’s your daily paycheck.": "直到 6 月 6 日为止，每天都会有少量时间价值从合约中流失——这​​就是你每天的薪水。",
  "Every option idea shows the annualized return next to assignment odds, time-to-expiration, expected volatility, and how easy it is to get filled. Never just the premium.": "每个期权想法都显示了被指派赔率、到期时间、预期波动性以及执行的容易程度旁边的年化回报。绝不只是权利金。",
  "Every Symbol Detail page shows the loss scenarios alongside the yield. The Learn section walks through what happens in a March-2020-style crash.": "每个代码详细信息页面都会显示损失情况以及收益率。 “学习”部分将介绍 2020 年 3 月类型的崩溃中发生的情况。",
  "Everything about one stock on a single page.": "有关一只股票的所有信息都在一页上。",
  "Expected move size — what options traders priced in.": "预期变动规模——期权交易者定价的内容。",
  "Expected profit per cycle given a win-rate and average win/loss sizes. The breakeven win-rate shows the minimum you need to be profitable at your current win-loss ratio.": "给定胜率和平均赢/输规模的每个周期的预期利润。盈亏平衡赢率显示了在当前盈亏比下您需要盈利的最低限度。",
  "Expected return per wheel cycle given win-rate and outcomes.": "根据胜率和结果估算每个轮转周期的预期回报。",
  "Expected vs actual": "预期与实际",
  "Expiration dates": "有效期",
  "Expiry pressure": "到期压力",
  "Far-OTM bet": "远-OTM 投注",
  "Filter loaded symbols": "过滤加载的代码",
  "FLOW DETAIL": "流向详情",
  "Flow detail requires Pro access.": "流向详情需要 Pro 权限。",
  "Flow read": "流向解读",
  "For a real book, size positions by their": "对于一本真正的书，按其持仓大小",
  "For legal questions, see our": "对于法律问题，请参阅我们的",
  "Forgot your password? Email us — password reset is currently handled by support.": "忘记密码了吗？给我们发电子邮件 — 密码重置目前由支持人员处理。",
  "Four steps from idea to managed trade.": "从创意到管理贸易的四个步骤。",
  "Free access": "Free 权限",
  "Free is the default plan. Create an account only when you want to save your workspace.": "Free 是默认套餐。只有在想保存工作区时才需要创建账户。",
  "Free trial (7 days, Pro 3-Month and Pro Annual only).": "Free 试用（7 天、Pro 3 个月和 Pro 年度）。",
  "Free trial.": "Free试用。",
  "Free: up to 10 symbols. Pro: unlimited.": "Free：最多 10 个代码。 Pro：无限制。",
  "From the company’s most recent SEC filing — period ending": "来自公司最近的 SEC 文件 — 期末日期",
  "from the email tied to the account. We will confirm before deleting.": "来自与帐户绑定的电子邮件。我们会在删除前确认。",
  "Full glossary": "完整词汇表",
  "Full options chain — puts and calls in two tabs.": "完整的期权链——两个期权卡中的看跌和看涨。",
  "full wheel": "轮转策略",
  "funds · total": "资金·总计",
  "Gamma and rho — skip for now. You can run the wheel for years without them.": "Gamma 和 rho——暂时跳过。没有它们，您可以运行数年。",
  "Gap %": "差距 ％",
  "Gap risk": "缺口风险",
  "Get help": "获得帮助",
  "get margin-called or take significant realized losses. Use this story as evidence of what’s possible with discipline, not as proof the strategy is crash-proof.": "被追缴保证金或承担重大已实现损失。用这个故事来证明纪律是可以实现的，而不是证明该策略是安全的。",
  "Get started": "开始使用",
  "Google API Services User Data Policy": "Google API 服务用户数据政策",
  "Google LLC": "Google LLC",
  "happen eventually.": "最终发生。",
  "Hashed passwords (email auth only), short-lived session and refresh tokens, the device fingerprint your browser sends with each request, and approximate sign-in timestamps used to detect abuse.": "哈希密码（仅限电子邮件身份验证）、短期会话和刷新令牌、浏览器随每个请求发送的设备指纹以及用于检测滥用的近似登录时间戳。",
  "Hedge Read": "对冲阅读",
  "held by": "持有者",
  "High = strongest UOA, Medium = worth checking, Watchlist = monitor only.": "高 = 最强 UOA，中 = 值得检查，自选 = 仅监控。",
  "High IV": "高 IV",
  "High IV vs RV + tight spread + meaningful OI + no catalyst in the way = a sellable contract.": "IV vs RV 高+价差小+有意义的持仓+没有催化剂=可出售合约。",
  "High Yield": "高产",
  "High-conviction flow": "高置信流向",
  "High-Vol CSP": "高波动 CSP",
  "holding period can also be broken by certain ITM calls — converting what would have been a 15-20% tax rate into ordinary-income rates.": "某些 ITM 呼吁也可能会打破持有期——将 15-20% 的税率转换为普通收入税率。",
  "How assignment actually feels": "被指派的实际感觉如何",
  "How expensive options are today vs. how much the stock has actually moved.": "今天的期权有多贵与股票实际变动了多少。",
  "How far back we're looking": "我们正在寻找多远的过去",
  "How it works": "它是如何运作的",
  "How many contracts can you sell while keeping risk per trade within your portfolio budget.": "在将每笔交易的风险控制在投资组合预算范围内的情况下，您可以出售多少份合约。",
  "How much option prices typically drop right after earnings is announced — selling premium can capture this drop.": "财报公布后期权价格通常会下跌多少——卖出权利金可以捕获这种下跌。",
  "How much option traders expect it to move (implied volatility)": "期权交易者期望其变动多少（隐含波动率）",
  "How much the stock actually moved (realized volatility)": "股票实际变动了多少（已实现波动率）",
  "How much the stock actually moved after earnings over the past few quarters.": "过去几个季度财报后，该股实际变动了多少。",
  "How often is the data refreshed?": "数据多久刷新一次？",
  "How options usually deflate (last": "期权通常如何缩减（最后",
  "If assigned → you now own 100 shares.": "如果被指派 → 您现在拥有 100 股。",
  "If paid plans return later, current titles, pricing, billing periods, trial terms, renewal behavior, and cancellation instructions will be shown before checkout.": "如果付费计划稍后返回，则结帐前将显示当前的标题、定价、计费周期、试用条款、续订行为和取消说明。",
  "If push notifications stop arriving, turn them off and back on at iOS Settings → NavOption → Notifications, then open the app once to refresh the token.": "如果推送通知停止到达，请在 iOS 设置 → NavOption → 通知中将其关闭并重新打开，然后打开应用程序一次以刷新令牌。",
  "If the call expires worthless → keep premium, keep shares, sell another call. If assigned away → take the gain, restart with a new put.": "如果看涨到期毫无价值→保留权利金，保留股票，卖出另一个看涨。如果被指派出去→获取收益，以新的看跌重新开始。",
  "If the call gets assigned at expiration, the max profit is appreciation to the strike plus the premium kept.": "如果看涨在到期时被指派，则最大利润是行权价的增值加上保留的权利金。",
  "If the put expires worthless → keep the premium → start again.": "如果看跌到期毫无价值→保留权利金→重新开始。",
  "If you joined TestFlight and the build is missing, make sure you accepted the latest tester invite email.": "如果您加入了 TestFlight 并且缺少构建，请确保您接受了最新的测试人员邀请电子邮件。",
  "If you remember one thing:": "如果你还记得一件事：",
  "If you start a 7-day free trial, you will not be charged during the trial. The trial converts automatically to a paid subscription at the end of day 7 unless you cancel at least 24 hours before the trial ends. You are entitled to at most one free trial per Apple ID, Google account, or email address. Pro Monthly does not include a free trial.": "如果您开始 7 天免费试用，则在试用期间不会向您收取费用。除非您在试用结束前至少 24 小时取消，否则试用将在第 7 天结束时自动转换为付费订阅。每个 Apple ID、Google 帐户或电子邮件地址最多有权获得一次免费试用。 Pro 每月不包含免费试用。",
  "If you’ve invested in stocks for years, some of your instincts will transfer to the wheel — and some will hurt you. Here’s the explicit list:": "如果你投资股票多年，你的一些本能会转移到轮转策略上，而另一些则会伤害你。这是明确的列表：",
  "Immediately after a sharp rally": "在大幅反弹之后",
  "Implied Move": "隐含的移动",
  "Implied move ±6.8%": "隐含波动 ±6.8%",
  "implied volatility": "隐含波动率",
  "Important caveat — survivorship bias": "重要警告——幸存者偏差",
  "In a taxable account, premium is taxed as a short-term capital gain (ordinary-income rates). A 13% wheel yield may net less than a 6% qualified-dividend yield depending on your bracket.": "在应税账户中，权利金作为短期资本利得（普通所得税率）征税。 13% 的轮转策略收益率可能低于 6% 的合格股息收益率，具体取决于您的级别。",
  "in flat or mildly-down markets and on stocks with high IV.": "在平坦或温和下跌的市场以及 IV 较高的股票上。",
  "In stocks you add on a 30% dip. In options, selling puts on a falling knife is how wheel traders get assigned at the worst moment. Wait for the dust to settle.": "在股票方面，你再加上 30% 的下跌。在期权中，在最糟糕的时刻，轮转交易者的被指派方式是在下落的刀上卖出看跌。等待尘埃落定。",
  "in strong rallies — your gain is capped at the premium.": "在强劲的反弹中——你的收益受到权利金的限制。",
  "In the wheel strategy,": "在轮转策略中，",
  "Income Trader": "收益交易者",
  "Inside the app": "应用程序内部",
  "Insider activity": "内幕活动",
  "Insider activity ·": "内幕活动·",
  "Insider transactions: net shares + net $ + most recent 12.": "内幕交易：净股+净美元+最近12股。",
  "Intraday snapshots": "日内快照",
  "iOS app issues": "iOS 应用程序问题",
  "iOS App Store purchases:": "iOS App Store 购买：",
  "IP address, user-agent, request path, and response status, used for security, abuse prevention, and debugging. Logs are typically retained for up to 90 days.": "IP 地址、用户代理、请求路径和响应状态，用于安全、滥用预防和调试。日志通常最多保留 90 天。",
  "is again the standard zone.": "又是标准区。",
  "is the common balance between premium decay and the gamma risk that comes with the final week (theta accelerates near expiry but so does the chance of a sudden assignment swing).": "是权利金衰减和最后一周的伽玛风险之间的共同平衡（θ 在到期日附近加速，但被指派突然波动的可能性也如此）。",
  "Is this real money advice?": "这是真正的金钱建议吗？",
  "IV Rank / ATM": "IV Rank / ATM",
  "IV Rank = (IV − low) ÷ (high − low) × 100": "IV Rank =（IV − 低点）÷（高点 − 低点）× 100",
  "IV Rank Calculator": "IV Rank 计算器",
  "Keep subscription": "保持订阅",
  "Large notional trade. Size matters, but it still needs moneyness, expiry, and trend context.": "名义贸易量大。规模很重要，但它仍然需要金钱、期限和趋势背景。",
  "Large single print": "大单打印",
  "Large single print — large notional": "大单印刷 — 大概念",
  "Large-cap, profitable, optionable, a chart you can sleep through. AAPL, MSFT, SPY are all reasonable beginner picks.": "大盘股、有利可图、可选择的图表，让您可以安然入睡。 AAPL、MSFT、SPY 都是合理的初学者选择。",
  "Last 3 days": "过去 3 天",
  "Last 7 days": "过去 7 天",
  "Last price": "最后价格",
  "Last refresh:": "上次刷新：",
  "Latest detection:": "最新检测：",
  "Latest financials": "最新财务数据",
  "Learn the wheel": "学习轮转策略",
  "Less option-chain noise. More strategy discipline.": "期权链噪音更少。更多的策略纪律。",
  "Lev. ETFs": "杠杆 ETF",
  "Likely hedge": "可能对冲",
  "Liquid contracts": "流动性合约",
  "Liquidity drying up": "流动性枯竭",
  "List 3 stocks you’d be happy to own at 10% below today’s price. These are your wheel candidates.": "列出 3 只您愿意以比今天价格低 10% 的价格持有的股票。这些是你的轮转候选标的。",
  "Live days-to-expiration, stock price gap, assignment risk.": "到期日、股价差距、转让风险。",
  "Live options chains from a major broker feed, SEC filings (insider trades + 13F + earnings), an independent technical cross-check, macro data, plus market news.": "来自主要券商的实时期权链、SEC 文件（内幕交易 + 13F + 财报）、独立技术交叉检查、宏观数据以及市场新闻。",
  "Live scanner": "实时扫描器",
  "Loading candidates...": "正在加载候选人...",
  "Loading chain...": "正在加载链...",
  "Loading chart...": "加载图表...",
  "Loading earnings...": "正在加载财报...",
  "Loading flow detail...": "加载流程详细信息...",
  "Loading hunts...": "正在加载狩猎...",
  "Loading ideas…": "正在加载想法...",
  "Loading live pricing...": "正在加载实时定价...",
  "Loading news...": "正在加载新闻...",
  "Loading positions...": "加载持仓...",
  "Loading scan...": "正在加载扫描...",
  "Loading snapshot...": "正在加载快照...",
  "Loading symbol overview...": "正在加载代码概述...",
  "Loading unusual options...": "正在加载异常期权...",
  "Loading watchlist...": "正在加载监视列表...",
  "Loading…": "加载中…",
  "Log your put or call. Watch the assignment risk live. When the expiration gets close, we rank the best rolls for you.": "记录您的看跌或看涨。实时观看被指派风险。当到期日临近时，我们会为您排名最好的卷。",
  "Long-dated positioning": "长期定位",
  "Long-term US-stock investors who want extra yield on stocks they’d already own.": "希望从已持有的股票中获得额外收益的长期美国股票投资者。",
  "Lottery — short-dated far-OTM speculative bet": "彩票 — 短期远期 OTM 投机性投注",
  "Low quality": "低质量",
  "Macro Hawk": "宏鹰",
  "macro-chip macro-event-": "宏观芯片宏观事件-",
  "macro-chip macro-regime-": "宏观芯片宏观制度-",
  "macro-chip macro-vix-": "宏芯片宏 vix-",
  "manage or cancel in the Stripe billing portal accessible from your": "在 Stripe 计费门户中管理或取消，可从您的",
  "manage or cancel in your Apple ID account settings (Settings → [Your Name] → Subscriptions). Deleting the app does not cancel the subscription.": "在你的 Apple ID 账户设置中管理或取消（设置 → [你的姓名] → 订阅）。删除 App 不会取消订阅。",
  "Manage your subscription, saved candidates, presets, alerts, and income-trade positions.": "管理您的订阅、已保存的候选人、预设、警报和收入交易持仓。",
  "Managing or cancelling a subscription.": "管理或取消订阅。",
  "Managing trades once they’re open": "交易开放后进行管理",
  "Market Snapshot": "市场概况",
  "Max DTE": "最大 DTE",
  "Max gap %": "最大间隙%",
  "Max IV": "最大 IV",
  "Max profit if the call gets assigned.": "如果呼叫被指派，则获得最大利润。",
  "Max profit/share = (strike − cost basis) + premium": "最大利润/股 = (行权价 − 成本基础) + 权利金",
  "median CC APY": "CC APY 中位数",
  "median CSP APY": "CSP APY 中位数",
  "Min Delta": "最小三角洲",
  "Min DTE": "最小值 DTE",
  "Missing:": "丢失的：",
  "Module 3": "模块 3",
  "Module 8": "模块 8",
  "Move the market is expecting": "市场正在期待搬迁",
  "My Hunt": "我的狩猎",
  "MY HUNT": "我的狩猎",
  "My Hunt rules": "我的狩猎规则",
  "My Hunt rules require Pro access.": "My Hunt 规则需要 Pro 权限。",
  "NavOption is an educational research workspace. Market data, options quotes, scanner output, Analyze reports, Wheel suggestions, position metrics, and any other Service output are provided for informational and educational purposes only and are not personalized investment advice, an offer to buy or sell any security, or a recommendation. Data may be delayed, incomplete, or incorrect. Free-tier users see quote data delayed by at least 15 minutes. You are solely responsible for your trading decisions.": "NavOption 是一个教育研究工作区。市场数据、期权报价、扫描器输出、Analyze 报告、轮转策略建议、持仓指标和任何其他服务输出仅供参考和教育目的，并非个性化的投资建议、购买或出售任何证券的要约或建议。数据可能有延迟、不完整或不正确。 Free 级别用户看到的报价数据至少延迟 15 分钟。您对您的交易决定承担全部责任。",
  "NavOption is currently free for every signed-in user. Paid plans may return later.": "NavOption 目前对所有登录用户免费。付费套餐之后可能恢复。",
  "NavOption is not directed to anyone under 18 and we do not knowingly collect personal information from children. If you believe a child has provided us information, contact us and we will delete it.": "NavOption 不针对 18 岁以下的任何人，我们不会故意收集儿童的个人信息。如果您认为儿童向我们提供了信息，请联系我们，我们将删除该信息。",
  "Near DTE": "临近 DTE",
  "near vs back": "近与后",
  "Need an export of your data? Email us — we’ll send you a JSON archive of your workspace.": "需要导出您的数据吗？给我们发电子邮件 — 我们将向您发送工作区的 JSON 存档。",
  "new positions · +": "新持仓·+",
  "NEWS · CATALYSTS": "新闻·催化剂",
  "News summaries": "新闻摘要",
  "Next Event": "下一个活动",
  "Next step": "下一步",
  "Next:": "下一个：",
  "No archived intraday snapshots for this alert date.": "此警报日期没有存档的日内快照。",
  "No candidates matched these filters.": "没有候选人符合这些过滤器。",
  "No chain data yet.": "尚无链数据。",
  "No contracts match the current filter.": "没有与当前过滤器匹配的合约。",
  "No current option-chain IV available.": "当前没有可用的期权链 IV。",
  "No daily history for this exact contract.": "没有该确切合约的每日历史记录。",
  "No earnings reports in the next": "未来无财报报告",
  "No hunt rules yet. Start with a symbol set and a notional threshold.": "还没有狩猎规则。从代码集和概念阈值开始。",
  "No ideas match this filter today.": "今天没有与此过滤器匹配的想法。",
  "No IV": "无 IV",
  "No news items right now.": "目前没有新闻。",
  "No open positions. Click \"+ Add position\" to log a trade.": "没有空缺持仓。点击“+添加持仓”来记录交易。",
  "No qualifying contract right now.": "目前没有合格合约。",
  "No sign-in history yet.": "还没有登录历史记录。",
  "No signal": "无信号",
  "No subscription records yet.": "还没有订阅记录。",
  "No subscription records yet. Pro plans purchased on the App Store or via Stripe will show up here.": "还没有订阅记录。通过 App Store 或 Stripe 购买的 Pro 套餐会显示在这里。",
  "No symbol-specific news in the current NavOption cache.": "当前 NavOption 缓存中没有该代码的新闻。",
  "No upcoming earnings within 14 days for": "14 天内没有即将发布的财报",
  "No urgent catalyst": "没有紧急催化剂",
  "No. NavOption is research-only — we never place trades on your behalf. Run the analysis here, place the trade in your broker.": "不会。NavOption 仅供研究 – 我们绝不会代表您进行交易。在这里运行分析，将交易交给您的券商。",
  "Now in CC leg": "现在在CC腿",
  "Number of contracts based on portfolio and risk per trade.": "基于投资组合和每笔交易风险的合约数量。",
  "NVDA · today": "NVDA · 今天",
  "NVDA 32D CSP $170": "NVDA 32D CSP $170",
  "of a stock. One person buys, one person sells.": "一只股票的。一个人买，一个人卖。",
  "of chain": "链的",
  "of two things happens (see Module 4).": "发生了两件事（参见模块 4）。",
  "On any stock page, scroll to the chain. The \"Bid\" column is the premium someone will pay you per share — multiply by 100 to get the cash that arrives today.": "在任何库存页面上，滚动到连锁店。 “出价”栏是某人愿意向您支付的每股权利金——乘以 100 即可得到今天到账的现金。",
  "On any stock page, the": "在任何库存页面上，",
  "On any stock page, the \"Option pricing right now\" card shows IV vs RV side-by-side. Look for rows where IV exceeds RV by ≥5 points.": "在任何股票页面上，“立即期权定价”卡片并排显示 IV 与 RV。查找 IV 超过 RV ≥5 个点的行。",
  "On Jun 6 (expiration),": "6月6日（到期），",
  "On single names": "关于单一名字",
  "On your iPhone, open Settings → [Your Name] → Subscriptions → NavOption → Cancel. Deleting the app alone does not cancel the subscription.": "在 iPhone 上，打开设置 → [你的姓名] → 订阅 → NavOption → 取消。只删除 App 不会取消订阅。",
  "One place from idea to exit": "从想法到退出仅一处",
  "one trader’s": "一位交易者的",
  "Open Interest": "未平仓合约",
  "Open positions": "未平仓持仓",
  "Open positions sync across web and iOS. PnL estimates update from live quotes.": "未平仓持仓会在 Web 和 iOS 之间同步。PnL 估算会根据实时报价更新。",
  "Open Scanner": "打开扫描器",
  "opening the trade, a maximum acceptable loss (typically 2× the premium collected) — past that, close or accept assignment. Don’t let a roll cycle convert a small loss into a large one.": "开仓交易，最大可接受损失（通常是收取的权利金的 2 倍）——超过该限额，关闭或接受转让。不要让移仓周期将小的损失变成大的损失。",
  "option ideas": "期权想法",
  "Option side": "期权侧",
  "Option-priced minus actual. Positive = options expensive, negative = cheap.": "期权价格减去实际价格。正=期权昂贵，负=便宜。",
  "Option-priced move": "期权价格变动",
  "Optional ticker": "可选代码",
  "Options chains every few minutes during US market hours. Earnings + 13F + insider on a daily cadence. Technical cross-check refreshes every 30 minutes during RTH.": "在美国市场交易时间内，期权每隔几分钟就会连锁一次。每日财报+13F+内幕消息。 RTH期间技术交叉检查每30分钟刷新一次。",
  "Options Depth": "期权深度",
  "Options income research preview": "期权收益研究预览",
  "Options income scanner.": "期权收入扫描器。",
  "Options snapshot": "期权快照",
  "Or browse": "或浏览",
  "Our backend host": "我们的后端主机",
  "Out-of-the-money (below the current price). Lower strike = less premium, lower chance of assignment. Most wheel traders target a": "价外（低于当前价格）。较低的行权价=较低的权利金，较低的被指派机会。大多数轮转交易者的目标是",
  "outcome. We don’t have the distribution of outcomes for the whole community, and many wheel traders": "结果。我们没有整个社区和许多轮转策略者的结果分布",
  "Over long periods, option IV on index ETFs (SPY, QQQ) has consistently been higher than the volatility that actually showed up. Selling that gap, in aggregate, has been profitable.": "长期以来，指数 ETFs（SPY，QQQ）上的期权 IV 一直高于实际出现的波动率。总的来说，卖出这个缺口是有利可图的。",
  "P(assignment) ≈ |delta| × 100%": "P(赋值) ≈ |delta| × 100%",
  "P/E thinking.": "市盈率思维。",
  "Paid plans are currently paused. Signed-in users can use the core NavOption workflow without choosing a paid tier.": "付费计划目前已暂停。登录用户可以使用核心 NavOption 工作流程，而无需选择付费套餐。",
  "Paid plans paused": "付费计划已暂停",
  "Paid subscriptions automatically renew at the end of each billing period at the then-current price unless you cancel at least 24 hours before the end of the current period. Your payment method will be charged for renewal within the 24-hour period prior to the end of the current period.": "付费订阅会在每个计费周期结束时按当时的价格自动续订，除非您在当前周期结束前至少 24 小时取消。您的付款方式将在当前期间结束前 24 小时内收取续订费用。",
  "panel shows the top covered-call candidate based on our scoring.": "面板根据我们的评分显示了最受保护的候选人。",
  "Paper loss on shares": "股票账面损失",
  "Paused billing": "暂停计费",
  "Payoff at expiry": "到期时支付",
  "Payoff curve": "收益曲线",
  "People allergic to ever holding the stock — assignment": "对持有股票过敏的人——作业",
  "People chasing 100%+ returns. This strategy caps your upside on purpose.": "人们追求 100% 以上的回报。这种策略有意限制了你的优势。",
  "People comfortable with a 10–25% annualized headline yield (the actual realized return is lower once you weight assignment scenarios — be honest with yourself).": "人们对 10-25% 的年化总体收益率感到满意（一旦你权衡被指派方案，实际实现的回报就会更低——对自己诚实）。",
  "People who need the cash next month — assignments tie up capital unpredictably.": "下个月需要现金的人——被指派会不可预测地占用资金。",
  "People with patience. A typical wheel trader checks positions once a week.": "有耐心的人。典型的轮转交易者每周检查一次持仓。",
  "Pick a stock you actually own. Sketch this 4-row table on paper using today’s price and a 10%-OTM put 35 days out. Do you prefer the shape of the wheel’s P/L, or the stock’s?": "选择一只您实际拥有的股票。使用今天的价格和 35 天后的 10%-OTM 在纸上绘制这个 4 行表格。您更喜欢轮毂 P/L 的形状还是库存的形状？",
  "Pick a stock, pick a strike you’d be glad to own at, pick 30–45 DTE, set aside the cash. That’s it.": "选择一只股票，选择您愿意持有的行权价，选择 30-45 DTE，留出现金。就是这样。",
  "Pick the expiration.": "选择过期时间。",
  "Pick the stock.": "选择股票。",
  "Pick the strike.": "选择行权价。",
  "Pick trades you can actually stomach.": "选择你真正能接受的交易。",
  "pin risk": "针风险",
  "PnL est": "PnL 估算",
  "PoP ≈ (1 − |delta|) × 100%": "PoP ≈ (1 − |delta|) × 100%",
  "Position sizing — risk-budgeted, not nominal": "持仓规模——风险预算，而非名义规模",
  "Position sizing as % of account.": "持仓规模占账户的百分比。",
  "Position Tracker": "持仓追踪器",
  "Premium / DTE / collateral": "权利金 / DTE / 担保金",
  "Premium $": "权利金 $",
  "Premium collected on options expiring worthless or closed before expiration:": "对到期时毫无价值或在到期前关闭的期权收取的权利金：",
  "Premium hits the account today": "高级版今天到账",
  "Premium isn’t a dividend. It’s ordinary income at tax time, and compounding into more CSPs concentrates risk, it doesn’t diversify it.": "权利金不是股息。这是纳税时的普通收入，复合到更多的 CSP 会集中风险，但不会分散风险。",
  "premium ranked by": "权利金排名按",
  "Premium yield and annualized return on collateral.": "权利金收益率和担保金年化回报率。",
  "Previous close": "上一个收盘价",
  "Price · Chg": "价格·更改",
  "Pricing after": "之后定价",
  "Pricing before": "之前定价",
  "Pricing columns": "定价栏",
  "Pricing page": "定价页面",
  "Priority:": "优先事项：",
  "Privacy questions or rights requests? Email": "隐私问题或权利请求？电子邮件",
  "Pro 3-Month": "Pro 3 个月",
  "Pro access": "Pro 权限",
  "Pro access continues until": "Pro 权限持续至",
  "Pro Annual": "Pro 年度",
  "Pro Monthly": "Pro 月度",
  "Pro plan": "Pro 套餐",
  "Pro unlocks the full scanner, saved workflow, alerts, Analyze, and daily market context.": "Pro 解锁完整扫描器、保存工作流、提醒、Analyze 和每日市场背景。",
  "Promo code": "优惠码",
  "Protection read": "保护性解读",
  "Put expires worthless": "看跌到期毫无价值",
  "Put-side pressure": "看跌压力",
  "puts ·": "看跌 ·",
  "Q)": "问）",
  "Qualified dividend holding period": "合格股息持有期",
  "Quality Score": "质量得分",
  "Quality Score = yield adjusted for risk + liquidity, with the reasons listed.": "质量评分 = 按风险和流动性调整后的收益，并列出原因。",
  "Quality Score weights APY against delta, liquidity, and IV — explained per row with cautions.": "质量得分将 APY 与 Delta、流动性和 IV 进行权重 — 每行进行解释，但需谨慎。",
  "Questions about these Terms? Email": "对这些条款有疑问吗？电子邮件",
  "Radar Signal": "雷达信号",
  "Radar signals": "雷达信号",
  "Reading the chain, managing trades, surviving bad weeks": "解读链条、管理交易、度过糟糕的几周",
  "Reading the option chain like a pro (without becoming a quant)": "像专业人士一样阅读期权链（无需成为宽客）",
  "Real numbers from today's option chain. Top track: puts expire worthless. Bottom track: assignment branch when the stock dips below your strike.": "来自今天期权链的实数。热门路线：看跌到期毫无价值。底部轨道：当股票跌破您的行权价时被指派分支。",
  "reason is that gamma rises as expiry approaches — closing at 50% captures most of the premium for less than half the duration, and dramatically reduces tail exposure to a late-cycle blow-up. Tasty Trade has published large-N backtests showing this materially improves win rate on SPY-like underlyings.": "原因是随着到期日的临近，伽马值会上升——收盘价为 50%，在不到一半的时间内捕获了大部分权利金，并大大减少了尾部对周期末期爆发的风险。 Tasty Trade 发布的大 N 回测表明，这极大地提高了类似 SPY 底层证券的胜率。",
  "Recent Analyze runs for": "最近的 Analyze 运行：",
  "Recent sign-ins": "最近登录",
  "Recommended Contracts": "推荐合约",
  "Related flow on": "相关流程",
  "Relevance label (high / medium / normal).": "相关性标签（高/中/普通）。",
  "Removed from watchlist": "已从监视列表中删除",
  "Repeat winner name": "重复获奖者姓名",
  "Reports in 9d": "9天后报告",
  "Reports inside the next": "下一篇里面的报道",
  "Research board": "研究委员会",
  "Research-only. You see the trade here, you place it in your broker. No keys, no trade execution, no surprises.": "仅供研究。您在这里看到交易，并将其放置在您的券商中。没有钥匙，没有交易执行，没有惊喜。",
  "return is lower once assignment scenarios are weighted — see": "一旦对被指派方案进行加权，回报就会较低 - 请参阅",
  "return is lower once you factor in the ~20% chance of assignment and the loss you’d take if AAPL gaps to $180.": "在计入约 20% 的被指派概率，以及 AAPL 跳空跌到 $180 时可能承受的损失后，实际回报会更低。",
  "Right before earnings": "就在财报之前",
  "Right before ex-dividend": "就在除息之前",
  "Risk discipline": "风险纪律",
  "Risk Manager": "风险经理",
  "Roll = close the current short option and open a similar one further out (later expiration) or at a different strike, ideally for net": "移仓 = 关闭当前的空头期权，并进一步打开类似的空头期权（稍后到期）或以不同的行权价，理想的净值",
  "ROLL CANDIDATES": "名册候选人",
  "Roll drawer ready": "卷筒抽屉准备就绪",
  "Row actions": "行动作",
  "Rule of thumb": "经验法则",
  "Run a scan against the live backend.": "对实时后端运行扫描。",
  "Run Analyze": "运行Analyze",
  "Run the wheel in an IRA when you can.": "尽可能在 IRA 中运行。",
  "Run the wheel on": "运行轮转策略：",
  "Running profit/loss estimate per leg.": "每条腿的运行盈利/亏损估计。",
  "Same-contract history": "相同合约历史",
  "Sample cycle": "样品周期",
  "Scaling up — from one CSP to a real book": "扩展——从一本 CSP 到一本真正的书",
  "Scan candidates": "扫描候选人",
  "Scan failed.": "扫描失败。",
  "Scan presets": "扫描预设",
  "Scanner + positions": "扫描器+持仓",
  "Scanner view mode": "扫描器查看模式",
  "Scanning live option chains...": "扫描实时期权链...",
  "Section 1256 contracts": "第1256章 合约",
  "Sector diversification.": "行业多元化。",
  "Sector filters": "扇区过滤器",
  "Sector spread": "行业分布",
  "See pricing": "查看定价",
  "See the honest comparison": "看看诚实的比较",
  "Sell $200 put": "卖出 200 美元看跌",
  "Sell $210 call": "卖出 210 美元看涨",
  "Sell a cash-secured put": "卖出现金担保看跌",
  "Sell a covered call": "卖出备兑看涨",
  "Sell a put": "卖出看跌",
  "sell or rent your personal information, and we do not use Sign in with Google data for advertising or any purpose beyond the features you sign in for. NavOption’s use of information received from Google APIs adheres to the": "出售或出租您的个人信息，并且我们不会将使用 Google 数据登录用于广告或超出您登录功能之外的任何目的。 NavOption 对从 Google API 接收的信息的使用遵循",
  "Sell puts only on companies you’d actually want to own. Your existing watchlist is a great starting point.": "只出售您真正想拥有的公司。您现有的监视列表是一个很好的起点。",
  "Selling options = collecting cash today in exchange for an obligation later.": "出售期权=今天收取现金以换取以后的义务。",
  "Server logs.": "服务器日志。",
  "Set aside the cash.": "把现金放在一边。",
  "Setup label: calm / watch / strong, so you know what to skip.": "设置标签：冷静 / 观察 / 强信号，帮你判断哪些可以跳过。",
  "Shared login": "共享登录",
  "shares at the strike. So the seller has the obligation to": "行权价时的股票。所以卖家有义务",
  "short calls": "短线通话",
  "short-term capital gain": "短期资本收益",
  "Side (call / put), how strong the signal is, why it tripped.": "侧面（看涨/看跌），信号有多强，为什么跳闸。",
  "sign in": "登入",
  "Sign in": "登入",
  "Sign in at": "登录于",
  "Sign in for today's market news": "登录以获取今日市场新闻",
  "Sign in to load alerts.": "登录以加载警报。",
  "Sign in to manage My Hunt rules.": "登录以管理“我的狩猎”规则。",
  "Sign in to save custom UOA alerts.": "登录后保存自定义 UOA 提醒。",
  "Sign in to see symbol-matched news from the NavOption market cache.": "登录后查看 NavOption 市场缓存中匹配该代码的新闻。",
  "Sign in to see today's unusual options activity.": "登录查看今天不寻常的期权活动。",
  "Sign in to track positions": "登录以跟踪持仓",
  "Sign in to use the watchlist.": "登录以使用监视列表。",
  "Sign in with Pro access to open full contract detail.": "使用有 Pro 权限的账户登录后查看完整合约详情。",
  "Signal guide": "信号引导",
  "Signup trial": "注册试用",
  "Slightly higher IV → bigger premium this time": "IV 略高 → 这次权利金更大",
  "Smart flow": "智能流向",
  "Smart Flow": "智能流程",
  "Smart Flow — OOS-validated bullish pattern": "Smart Flow — OOS 验证的看涨模式",
  "something is happening": "有事正在发生",
  "Sorted by relevance.": "按相关性排序。",
  "Speculative lotto": "投机乐透",
  "Spread across the 11 GICS sectors (tech, financials, healthcare, energy, consumer staples, consumer discretionary, industrials, utilities, real estate, materials, communications). But — sectors are not equal-risk: SPX tech is ~30% of the index.": "分布在 11 个 GICS 行业（科技、金融、医疗保健、能源、必需消费品、非必需消费品、工业、公用事业、房地产、材料、通信）。但是，各个行业的风险并不相同：SPX 科技股约占该指数的 30%。",
  "Standard UOA": "标准 UOA",
  "Start free. Upgrade when the workflow becomes daily.": "开始免费。当工作流程变为日常时升级。",
  "Start here": "从这里开始",
  "Stock above your strike": "股票高于您的行权价",
  "Stock acquired via put assignment: cost basis = strike × 100 − premium collected.": "通过看跌获得的股票：成本基础=行权价×100-收取的权利金。",
  "Stock below your strike": "股票低于你的行权价",
  "Stock dips to $190": "股价跌至 190 美元",
  "Stock held above $200 — start the next cycle": "股票保持在 200 美元以上 — 开始下一个周期",
  "Stock selection.": "选股。",
  "Stock sitting right on the strike": "股票正好处于行权价状态",
  "Strategy A": "策略A",
  "Strategy B": "策略B",
  "Strike × 100 = the cash that has to sit untouched in your account until expiration.": "行权价 × 100 = 到期前必须保留在您账户中的现金。",
  "Strike $": "行权价$",
  "Strike above cost basis. Avoid earnings and ex-dividend dates. Premium should be worth more than the upside you’re capping.": "行权价高于成本基础。避开财报日和除息日。权利金应该比你所限制的上涨空间更有价值。",
  "Strikes are hidden until you sign in.": "在您登录之前，行权价是隐藏的。",
  "Stripe record": "Stripe 记录",
  "Stripe subscription": "Stripe 订阅",
  "Stripe, Inc.": "Stripe, Inc.",
  "Strong Buy": "强力买入",
  "Strong Sell": "强力卖出",
  "structurally short vega": "结构性做空 vega",
  "Subscription and billing.": "订阅和计费。",
  "Subscription history": "订阅历史",
  "Subscription tier, plan ID, trial status, renewal/expiry dates, and the Stripe customer ID or Apple original transaction ID associated with your account. We do": "订阅等级、计划 ID、试用状态、续订/到期日期以及与您的账户关联的 Stripe 客户 ID 或 Apple 原始交易 ID。我们做",
  "Subscriptions, trials, and refunds": "订阅、试用和退款",
  "Switched to credit spreads and shorter-DTE trades while vol was elevated, instead of stopping completely.": "在交易量上升的同时转向信用价差和短期 DTE 交易，而不是完全停止。",
  "Symbol chain unavailable": "代码链不可用",
  "Symbol detail sections": "代码详细信息部分",
  "Taxes — a US-focused playbook": "税收——以美国为中心的策略",
  "Taxes, scaling, routines": "税收、规模、惯例",
  "Tech read": "技术阅读",
  "Term slope": "期限斜率",
  "The 4-step recipe:": "4步步骤：",
  "The 50% rule": "50%规则",
  "The 7-day trial on Pro 3-Month and Pro Annual converts automatically to a paid subscription unless cancelled at least 24 hours before day 7 ends.": "Pro 3 个月和 Pro 年度的 7 天试用将自动转换为付费订阅，除非在第 7 天结束前至少 24 小时取消。",
  "The biggest mental shift: as an equity investor your payoff is": "最大的心理转变：作为股权投资者，你的回报是",
  "the day before a stock goes ex-dividend (the call holder exercises to capture the dividend). If you’re running a covered call into an ex-dividend date with the strike near or below the current price, expect to be called early.": "股票除息前一天（看涨期权持有人行权以获取股息）。如果您在除息日进行备兑看涨，且行权价接近或低于当前价格，则预计会提前被提前指派。",
  "the gap often compensates for binary risks — earnings, M&A, court rulings. The IV-vs-RV signal is a starting screen, not a license to print money.": "这种差距通常可以弥补二元风险——财报、并购、法院裁决。 IV-vs-RV 信号是一个起始屏幕，而不是稳赚许可。",
  "The greeks you actually need": "你真正需要的希腊值",
  "The headline math: if the put expires worthless you earned $250 on $20,000 of locked capital in 35 days — that’s ~1.25%, or ~13% annualized.": "标题数学：如果看跌到期一文不值，您在 35 天内通过 20,000 美元的锁定资本赚取 250 美元 - 约为 1.25%，或年化约为 13%。",
  "The honest list — so you know what you’re getting.": "诚实的清单——这样你就知道你得到了什么。",
  "The market headlines that matter for your symbols.": "对您的代码重要的市场头条新闻。",
  "The move option traders are pricing in for earnings, based on at-the-money calls + puts.": "期权交易者根据平价看涨+看跌来定价财报。",
  "the premium you collected. Example: assigned at $200 strike with $2.50 premium collected → effective cost basis $197.50.": "您收取的权利金。示例：以 200 美元的行权价被指派，收取 2.50 美元的权利金 → 有效成本基础为 197.50 美元。",
  "The product does not promise returns or place trades. It helps compare setups consistently and pressure-test the thesis before you commit capital.": "产品不承诺回报，也不会代你下单。它帮助你一致地比较交易方案，并在投入资金前压力测试投资逻辑。",
  "The questions we get most often.": "我们最常收到的问题。",
  "The Service is offered with a Free tier and one or more paid tiers (currently Pro Monthly, Pro 3-Month, and Pro Annual). Current titles, pricing, billing periods, and trial terms are listed on the": "该服务提供 Free 等级和一个或多个付费等级（目前为 Pro 每月、Pro 3 个月和 Pro 年度）。当前的标题、定价、计费周期和试用条款列于",
  "THE SERVICE IS PROVIDED “AS IS” AND “AS AVAILABLE” WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, ACCURACY, OR UNINTERRUPTED OPERATION.": "本服务按“原样”和“可用”提供，不附有任何明示或暗示的保证，包括但不限于适销性、特定用途的适用性、不侵权、准确性或不间断运行。",
  "The Service, including all software, text, graphics, audio, video, and other content (other than user content) is owned by or licensed to NavOption and is protected by intellectual property law. Subject to these Terms, we grant you a limited, non-exclusive, non-transferable, revocable license to use the Service for your personal, non-commercial research workflow.": "本服务，包括所有软件、文本、图形、音频、视频和其他内容（用户内容除外）均归NavOption所有或授权给NavOption，并受知识产权法保护。根据这些条款，我们授予您有限的、非独占的、不可转让的、可撤销的许可，以将服务用于您的个人、非商业研究工作流程。",
  "The structural risks you’re carrying": "您所承受的结构性风险",
  "The top cash-secured-put and covered-call ideas across the market, ranked by risk-adjusted yield.": "市场上顶级的现金担保看跌和备兑看涨创意，按风险调整后收益率排名。",
  "The variance risk premium — the real reason wheel works on average": "方差风险权利金——轮转策略平均有效的真正原因",
  "The wheel": "轮转策略",
  "The wheel earns 10–25% annualized on average for disciplined traders in flat markets — and bleeds in sharp rallies and crashes.": "对纪律严格的交易者来说，轮转策略在横盘市场中平均可获得 10–25% 年化收益；但在急涨和暴跌中都会受伤。",
  "The wheel is a flat-market and sideways-market strategy. It is not a bull-market strategy.": "轮转策略适合横盘或震荡市场，不是牛市追涨策略。",
  "The wheel is a recurring three-step (often four-step) income strategy on a stock you actually want to own. Each step pays you:": "轮转策略是针对您真正想要拥有的股票的经常性三步（通常是四步）收入策略。每一步都会为您带来回报：",
  "These Terms are governed by the laws of the State of California, United States, without regard to its conflict-of-law principles. Any dispute will be resolved in the state or federal courts located in San Francisco County, California, except where applicable consumer protection law gives you the right to bring a claim in your local courts.": "这些条款受美国加利福尼亚州法律管辖，不考虑其法律冲突原则。任何争议将在位于加利福尼亚州旧金山县的州法院或联邦法院解决，除非适用的消费者保护法赋予您向当地法院提出索赔的权利。",
  "These Terms of Service (the “Terms”) govern your access to and use of NavOption, including the navoption.com website, the admin console, the iOS application, and all related software, content, and APIs (collectively, the “Service”). By creating an account or using the Service you agree to these Terms.": "这些服务条款（“条款”）管辖您对 NavOption 的访问和使用，包括 navoption.com 网站、管理控制台、iOS 应用程序以及所有相关软件、内容和 API（统称为“服务”）。创建帐户或使用服务即表示您同意这些条款。",
  "Theta Decay (Rough)": "Theta 衰减（粗略）",
  "they pay (the fourth income stream).": "他们支付（第四种收入来源）。",
  "This alert is no longer available in the detail archive.": "此警报在详细档案中不再可用。",
  "This is": "这是",
  "this is the yield if you do not get assigned. Your": "这是如果您没有被指派的收益。你的",
  "This Privacy Policy explains what information NavOption collects, how we use it, and the choices you have. It applies to the NavOption website, iOS application, admin console, and APIs.": "本隐私政策解释了 NavOption 收集哪些信息、我们如何使用这些信息以及您拥有的选择。它适用于NavOption网站、iOS应用程序、管理控制台和API。",
  "To create and operate your account and sync your workspace.": "创建和操作您的帐户并同步您的工作区。",
  "To improve features, fix bugs, and produce aggregated, de-identified usage statistics.": "改进功能、修复错误并生成汇总的、去识别化的使用统计数据。",
  "To prevent fraud, abuse, account sharing, and security incidents.": "防止欺诈、滥用、帐户共享和安全事件。",
  "To process subscriptions, trials, and renewals.": "处理订阅、试用和续订。",
  "to see SEC Form 4 insider buy / sell flow for": "查看 SEC Form 4 内部人买入 / 卖出流向：",
  "to see the full contract.": "查看完整的合约。",
  "To send transactional and product notifications (e.g., position roll candidates, alerts you set up). Push notifications can be disabled in your device settings or in-app.": "发送交易和产品通知（例如持仓移仓候选、你设置的提醒）。你可以在设备设置或 App 内关闭推送通知。",
  "TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, NAVOPTION AND ITS AFFILIATES WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR FOR LOST PROFITS, REVENUES, DATA, OR TRADING LOSSES, ARISING FROM OR IN CONNECTION WITH THE SERVICE. OUR AGGREGATE LIABILITY FOR ANY CLAIM RELATED TO THE SERVICE WILL NOT EXCEED THE AMOUNTS YOU PAID US FOR THE SERVICE IN THE TWELVE MONTHS BEFORE THE CLAIM.": "在适用法律允许的最大范围内，NAVOPTION 及其附属公司对因服务引起的或与服务相关的任何间接、偶然、特殊、后果性或惩罚性损害，或者利润损失、收入、数据或交易损失不承担任何责任。我们对与服务相关的任何索赔的总责任不会超过您在索赔前十二个月内向我们支付的服务金额。",
  "Today (May 1): +$250 cash hits your account. $20,000 is set aside.": "今天（5 月 1 日）：+250 美元现金存入您的账户。预留 20,000 美元。",
  "Today only": "仅限今天",
  "Today Vol": "今日卷",
  "Today's contracts traded vs each strike's typical 7-day baseline. Bigger multiple = more unusual flow.": "今天的合约交易与每次行权价的典型 7 天基准相比。倍数越大=流向越不寻常。",
  "Today's market news": "今日市场消息",
  "Today's UOA": "今日 UOA",
  "Today’s volume vs. the 7-day average, per strike.": "今日成交量与 7 天平均每次行权价的对比。",
  "Today's wheel ideas": "今日轮转机会",
  "Top picks — sell the put, get assigned, then sell the call.": "首选——卖出看跌，获得被指派，然后卖出看涨。",
  "Top track: puts expire worthless, you keep $510 on $20K (~10.3% APY). Bottom track shows the assignment branch.": "上方路径：看跌到期归零，你在 $20K 担保金上留下 $510（约 10.3% APY）。下方路径展示被指派分支。",
  "Total = (symbols × avg strike × 100 × contracts) × (1 + cushion%)": "总计 = (代码 × 平均行权价 × 100 × 合约) × (1 + 缓冲%)",
  "Track every put and call you sell, from open to close.": "跟踪您卖出的每笔看跌和看涨，从开盘到平仓。",
  "Trial ended. You are now on Free.": "试用已结束。你现在是 Free 套餐。",
  "trimmed · -": "修剪过·-",
  "Try a few popular wheel-friendly stocks to get started:": "先试试几个常见的轮转友好股票：",
  "Try this on NavOption:": "在 NavOption 上试试看：",
  "Two flavors of contracts exist:": "存在两种类型的合约：",
  "Underlined terms across the rest of the site link back here.": "网站其余部分的下划线术语链接返回此处。",
  "Underlying price": "基础价格",
  "Unlimited saved symbols while paid plans are paused.": "付费计划暂停时可无限保存代码。",
  "Unusual Flow": "异常流程",
  "UNUSUAL OPTIONS ACTIVITY": "异动期权活动",
  "UOA flow detail": "UOA 流向详情",
  "Upcoming earnings, expected move, volatility, insider trades, and big-fund holdings sit next to the yield number.": "财报率数据旁边是即将公布的财报、预期走势、波动性、内幕交易和大基金持有量。",
  "Upgrade to Pro": "升级到 Pro",
  "Upside / Downside target": "上行/下行目标",
  "Used only ~50% of buying power on CSPs — the other half was reserves for rolling and absorbing assignments.": "仅使用了约 50% 的 CSP 购买力，另一半用于移仓和吸收被指派的储备。",
  "VIX above 35 is a \"stop opening, manage what you have\" zone for most retail-sized accounts.": "VIX 高于 35 是大多数零售规模账户的“停止开户，管理您拥有的”区域。",
  "Vol regime awareness": "卷制度意识",
  "Vol-spike convexity": "波动率凸性",
  "Volatility setup": "波动率设置",
  "Volume / OI": "体积/OI",
  "vs baseline": "与基线",
  "Want to delete your account? Email": "想要删除您的帐户吗？电子邮件",
  "Wash sales": "洗售",
  "Watching DTE / gap%": "观察 DTE / 跳空幅度%",
  "Watchlist + Positions sync both ways. Same account, same data, same Analyze history.": "关注列表 + 持仓双向同步。相同的帐户，相同的数据，相同的 Analyze 历史记录。",
  "Watchlist, presets, alerts, positions, and notes sync automatically across web and iOS once you sign in.": "登录后，关注列表、预设、警报、持仓和注释会在网络和 iOS 上自动同步。",
  "Watchlists, scan presets, alerts, positions, notes, and Analyze runs you create. We use this only to provide the Service and sync it across devices you sign in to.": "您创建的监视列表、扫描预设、警报、持仓、注释和 Analyze 运行。我们仅使用它来提供服务并在您登录的设备之间同步它。",
  "We collect only what we need to provide the Service:": "我们仅收集提供服务所需的信息：",
  "We do": "我们做",
  "We don’t auto-train ML on your data": "我们不会根据您的数据自动训练机器学习",
  "We don’t connect to your brokerage": "我们不连接到您的券商",
  "We don’t hide the losses": "我们不隐瞒损失",
  "We don’t promise returns": "我们不承诺回报",
  "We focus on US equities and ETFs with liquid options. If a ticker is too thinly traded for a reliable wheel trade, we skip it on purpose.": "我们专注于美国股票和具有流动性期权的 ETFs。如果某个股票的交易量太少，无法进行可靠的轮转策略交易，我们会故意跳过它。",
  "We rely on the following processors and providers:": "我们依赖以下处理商和提供商：",
  "We retain account and workspace data while your account is active. If you delete your account, we delete or anonymize personal data within 30 days, except records we are required to keep for tax, accounting, fraud-prevention, or legal-compliance reasons (typically up to 7 years for billing records).": "当您的帐户处于活动状态时，我们会保留帐户和工作区数据。如果您删除帐户，我们会在 30 天内删除或匿名化个人数据，但出于税务、会计、防欺诈或法律合规原因而需要保留的记录除外（账单记录通常最长可达 7 年）。",
  "We share information with the providers above only as needed to operate the Service, and with law enforcement when we have a good-faith belief we are legally required to do so. We do not share workspace content with third parties for marketing.": "我们仅在运营服务所需时与上述提供商共享信息，并在我们确信法律要求我们这样做时与执法板块共享信息。我们不会出于营销目的与第三方共享工作区内容。",
  "We will update the effective date above when we change this Policy. For material changes, we will give you reasonable advance notice in-app or by email.": "当我们更改本政策时，我们将更新上述生效日期。对于重大变更，我们将在应用内或通过电子邮件向您发出合理的提前通知。",
  "Weak follow-through": "后续行动薄弱",
  "Web ↔ iOS sync": "Web ↔ iOS 同步",
  "Web purchases (Stripe):": "Web 购买（Stripe）：",
  "What actually happened (last": "实际发生了什么（最后",
  "What big funds own ·": "大基金拥有什么·",
  "What big funds own (13F filings) + your past AI runs.": "大基金拥有什么（13F备案）+您过去的AI运行。",
  "What data sources do you use?": "您使用哪些数据源？",
  "What goes wrong — the March 2020 case study (and its limits)": "出了什么问题——2020 年 3 月的案例研究（及其局限性）",
  "What that trader did right": "该交易员做对了什么",
  "What we don’t do": "我们不做什么",
  "What you get": "你得到什么",
  "WHEEL TOOLS ·": "轮转工具 ·",
  "Wheel vs. buy-and-hold.": "轮转策略与买入并持有。",
  "When an open short option has lost ~50% of its initial value, close it. The popular justification is \"free up capital.\" The": "当未平仓空头期权损失了其初始价值的约 50% 时，将其平仓。流行的理由是“释放资本”。这",
  "When expiration gets close, ranked roll suggestions appear.": "当到期日临近时，会出现排名移仓建议。",
  "When NOT to sell a covered call": "何时不出售备兑看涨",
  "When VIX flips to backwardation (short-dated higher)": "当 VIX 翻转至现货权利金时（短期走高）",
  "When VIX is in contango (longer-dated higher than shorter-dated) the wheel feels easy.": "当 VIX 处于期货权利金（长期高于短期）时，轮转策略感觉很轻松。",
  "Where current IV sits inside the last-year range (0–100).": "当前 IV 在过去一年区间中的位置（0–100）。",
  "Where institutional money is unusually active today.": "如今，机构资金异常活跃。",
  "Where rolling becomes a trap": "移仓成为陷阱的地方",
  "While you hold the shares, collect any": "当您持有股票时，收集任何",
  "Why are some symbols missing from the scanner?": "为什么扫描器中缺少一些代码？",
  "Why it helps": "为什么有帮助",
  "Why it matters:": "为什么它很重要：",
  "with a short description of the issue, the page or screen you were on, and your account email. Screenshots help.": "包含问题的简短描述、您所在的页面或屏幕以及您的帐户电子邮件。截图有帮助。",
  "with downside moves, so call premium can actually rise. The dynamic between volatility and stock direction is not always intuitive.": "随着下行走势，看涨权利金实际上可能会上升。波动率和股票方向之间的动态并不总是直观的。",
  "With positions": "有持仓",
  "Workspace data": "工作区数据",
  "Workspace data.": "工作区数据。",
  "Yield math": "产量数学",
  "Yield with the risk in plain sight": "收益与风险一目了然",
  "You agree not to (a) reverse engineer or scrape the Service, (b) resell or sublicense access, (c) attempt to bypass tier limits, rate limits, or security mechanisms, (d) upload unlawful content, or (e) use the Service to provide investment advice to third parties as a regulated activity.": "您同意不会 (a) 对服务进行逆向工程或抓取，(b) 转售或再许可访问权限，(c) 尝试绕过等级限制、速率限制或安全机制，(d) 上传非法内容，或 (e) 使用服务向第三方提供投资建议作为受监管的活动。",
  "You agree to indemnify and hold harmless NavOption and its affiliates from any claim or liability arising out of your use of the Service or your violation of these Terms.": "您同意赔偿因您使用本服务或违反本条款而引起的任何索赔或责任，并使 NavOption 及其关联公司免受损害。",
  "you are always the seller": "你永远是卖家",
  "You can resubscribe anytime from the Pricing page.": "您可以随时从定价页面重新订阅。",
  "You can sign in with email and password, Sign in with Apple, or Sign in with Google. The same email address always maps to the same NavOption account.": "您可以使用电子邮件和密码登录、使用 Apple 登录或使用 Google 登录。相同的电子邮件地址始终映射到相同的 NavOption 帐户。",
  "You can subscribe again anytime from the Pricing page.": "您可以随时从定价页面再次订阅。",
  "You have not been charged. No charge will happen.": "您尚未被指控。不会产生任何费用。",
  "You may create an account using an email and password, Sign in with Apple, or Sign in with Google. You agree to keep your credentials secure, to provide accurate information, and to be responsible for everything that happens under your account. We may suspend or terminate accounts that we reasonably believe are shared across multiple users, are used to scrape the Service, or otherwise violate these Terms.": "您可以使用电子邮件和密码创建帐户，使用 Apple 登录，或使用 Google 登录。您同意保证您的凭据安全，提供准确的信息，并对您帐户下发生的一切负责。我们可能会暂停或终止我们合理认为由多个用户共享、用于窃取服务或以其他方式违反这些条款的帐户。",
  "You may stop using the Service at any time and request account deletion by contacting": "您可以随时停止使用服务并通过联系请求删除帐户",
  "You must be at least 18 years old and have the legal capacity to enter into a contract in your jurisdiction. The Service is intended only for residents of jurisdictions where U.S. equity and options market data may lawfully be received. You are responsible for verifying that your use complies with local law and any rules imposed by your broker.": "您必须年满 18 岁，并且在您所在的司法管辖区具有签订合约的法律行为能力。该服务仅适用于可以合法接收美国股票和期权市场数据的司法管辖区的居民。您有责任验证您的使用是否符合当地法律以及券商施加的任何规则。",
  "You own the shares — selling covered calls": "您拥有股票——出售备兑看涨",
  "You retain ownership of the watchlists, presets, alerts, positions, notes, and other content you create in NavOption (“User Content”). You grant NavOption a worldwide, non-exclusive license to host, store, process, and transmit your User Content solely to operate the Service for you, to back it up, and to display it on devices you sign in to.": "您保留您在 NavOption 中创建的监视列表、预设、警报、持仓、注释和其他内容（“用户内容”）的所有权。您授予 NavOption 全球范围内的非排他性许可，以托管、存储、处理和传输您的用户内容，仅用于为您操作服务、备份服务以及在您登录的设备上显示服务。",
  "You were assigned. Now you’re in the": "你被指派了。现在你在",
  "You're on Pro.": "你正在使用 Pro。",
  "You’re paid": "您已获得报酬",
  "You're still in your free trial": "您仍处于免费试用期",
  "Your position here": "你在这里的持仓",
  "Your Pro plan is managed by the App Store (iOS). Use Settings → Subscriptions on your iPhone / iPad to update.": "你的 Pro 套餐由 App Store（iOS）管理。请在 iPhone / iPad 的“设置 → 订阅”中更新。",
  "Your saved symbols, in sync across web and iOS.": "您保存的代码在网络和 iOS 上同步。",
  "Your strike vs expected high": "您的行权价与预期高价",
  "Your symbols": "你的代码",
  "Your watchlist is empty.": "您的关注列表是空的。",
  "YoY EPS": "每股收益同比",
  "Δ shares": "Δ股",

  // Item 2: UOA strike=0 paywall copy
  "Sign in to see this contract.": "登录后查看此合约。",
  "Pro unlocks strike prices.": "Pro 版解锁行权价。",

  // Item 3: Discover watchlist quick-add
  "Already on your watchlist": "已在自选列表中",
  "Add to watchlist": "添加到自选",
  "+ Watch": "+ 自选",
  "Watchlist quota reached — upgrade to Pro for more symbols.": "自选列表已达上限，升级 Pro 可添加更多标的。",

  // Item 4: UOA Hunts feedback loop
  "Alerts are delivered as push notifications via the iOS app. Manage in app Settings → Notifications.": "提醒通过 iOS App 推送通知发送。在 App 的设置 → 通知中管理。",
  "Last triggered:": "上次触发：",
  "fired": "近 30 天触发",
  "× in 30d": "次",
  "Loading trigger history…": "正在加载触发历史…",
  "No trigger history yet.": "暂无触发历史。",
  "History": "历史",
  "Sent": "发送时间",

  // Item 5: Screener landing pages
  "COVERED CALLS": "备兑看涨",
  "Covered Call Screener": "备兑看涨筛选器",
  "Collect income on stocks you already own. Sell a call above your cost basis, keep the premium upfront, and let time decay work in your favor. If the stock stays below the strike, you keep the premium and repeat.": "在你已持有的股票上收取收入。在成本价上方卖出看涨期权，先收取权利金，让时间价值衰减为你工作。如果股价保持在行权价以下，你保留权利金并重复操作。",
  "Ranked by quality score — premium yield, liquidity, and distance from price.": "按质量评分排名，包含权利金收益率、流动性和距现价距离。",
  "Delta and IV shown for every contract so you can calibrate risk at a glance.": "每份合约均显示 Delta 和 IV，一眼即可评估风险。",
  "Filter by sector, DTE, or search a specific symbol.": "按板块、DTE 筛选，或搜索特定标的。",
  "Create a free account": "创建免费账户",
  "CASH-SECURED PUTS": "现金担保看跌",
  "Cash-Secured Put Screener": "现金担保看跌筛选器",
  "Get paid to wait for the price you already wanted. Sell a put below today's price, collect premium upfront, and either keep the cash when it expires worthless or buy the stock at the discount you had in mind.": "等待你心目中的价格，同时获得收入。在当前价格下方卖出看跌期权，先收取权利金，到期归零时保留现金，或以你原本想要的折扣买入股票。",
  "Gap percentage shows how far the underlying must fall before you are assigned.": "缺口百分比显示标的需要下跌多少才会触发被指派。",

  // Item 6: Analyze quota pre-warning
  "1 deep run left this month · resets": "本月剩余 1 次深度分析 · 重置于",
  "1 fast run left this month · resets": "本月剩余 1 次快速分析 · 重置于",
  "Upgrade to Pro for more": "升级 Pro 获取更多次数",

  // Item 7: Scan empty-state recovery hint
  "No contracts match the current filters.": "当前筛选条件下无合约。",
  "Raising the IV cap to": "将 IV 上限提高到",
  "would show": "将显示",
  "contract.": "份合约。",
  "contracts.": "份合约。",
  "Lowering the minimum APY to": "将最低 APY 降低到",
  "Extending the max DTE to": "将最大 DTE 延长到",
  "days would show": "天将显示",
  "Adjusting the delta threshold to": "将 Delta 阈值调整到",
  "Relaxing filters would show": "放宽筛选条件将显示",
  "Reset filters": "重置筛选",

  // Item 8: Positions summary card
  "open": "个仓位",
  "capital at risk": "风险资本",
  "premium collected": "已收权利金",
  "net delta (share-equiv)": "净 Delta（等效股数）",
  "Share-equivalent directional exposure of your short options. +420 means roughly the same direction risk as holding 420 shares.": "卖出期权的等效股数方向敞口。+420 约等于持有 420 股的方向性风险。",
  "of capital at risk concentrated in": "% 风险资本集中在",
  "Roll window (≤21 DTE)": "移仓窗口（≤21 DTE）",
  "All open positions are in the roll window above.": "所有持仓均已在上方移仓窗口中。",

  // Item 9: OI confirmed badge
  "Open interest rose next session — consistent with opening flow, not closing": "次日未平仓量上升——与开仓性资金流一致（而非平仓）",

  // Insider signal summary
  "Insiders net buying": "内部人净买入",
  "Insiders net selling": "内部人净卖出",
  "Mixed insider activity": "内部人交易方向不一",
  "· incl. CEO/CFO": "· 含 CEO/CFO",

  // Item 10: Earnings gating copy
  "Position-aware earnings prep (earnings card in Analyze)": "持仓感知财报准备（Analyze 中的财报卡）",
  "Position-aware earnings prep across full Wheel cycles": "贯穿完整轮转周期的持仓感知财报准备",

  // Feature 1: Earnings preview enrichment
  "typical move": "典型波动",
  "avg of last": "近",
  "reports)": "次财报均值）",
  "Past data only — not a prediction of future moves.": "仅为历史数据——并非对未来走势的预测。",
  "Report date": "报告日期",
  "Realized move": "实际波动",
  "EPS surprise": "EPS 超预期",

  // Feature 2: Recent reports recap
  "Recent reports — your symbols (7d)": "近期财报 — 你的标的（7天）",
  "Actual EPS": "实际 EPS",
  "Surprise": "超预期",
  "Move": "波动",
  "IV crush (before → after)": "IV 挤压（财报前 → 后）",
  "Implied volatility usually drops sharply right after earnings — this 'IV crush' is why options can lose value even when the direction was right.": "财报后隐含波动率通常会骤降——这种 'IV 挤压' 是方向看对了期权仍可能亏损的原因。",

  // Feature 3: NL scan input
  "Couldn't map:": "无法识别：",

  // Feature 4: Position thesis
  "Thesis (why this trade)": "投资逻辑（为何做这笔交易）",
  "Optional — e.g. comfortable owning at this price": "可选——例如：愿意在此价格持有",

  // Feature 5: Tear sheet export
  "Export tear sheet": "导出简报",
  "Next earnings:": "下次财报：",
  "Implied move (next earnings)": "隐含波动（下次财报）",
  "Insider signal:": "内部人信号：",
  "Data: NavOption research · Generated": "数据来源：NavOption 研究 · 生成于",
  "· For informational purposes only. Not investment advice.": "· 仅供参考，不构成投资建议。",

  // Feature 6: Verdict rating + falsifier
  "Buy": "买入",
  "Lean bullish": "偏多",
  "Hold": "持有",
  "Lean bearish": "偏空",
  "Sell": "卖出",
  "What would change this view:": "哪些情况会改变这一观点：",
  "Yes, the core scanner, stock analysis, watchlist, and position tracker are free. Paid Pro tier unlocks extras (insider history, peer comparison, and volatility bands) — clearly marked on the pricing page.": "是的，核心扫描器、个股分析、自选列表和持仓跟踪都免费。付费 Pro 套餐解锁内部人历史、同业对比和波动区间等额外内容，定价页会明确标注。",
  "It reviews available filings and market data for cash flow, debt, revenue, and price volatility. Results identify risks found by the checks and show which data was unavailable. “No major issues found” applies only to the checks performed; it is not a valuation or trading recommendation.": "它会根据可用的申报文件和市场数据查看现金流、债务、营收和价格波动。结果会列出检查发现的风险和缺失的数据。“未发现明显问题”仅适用于已完成的检查，不代表估值结论或交易建议。",
  "Stock risks explained clearly": "清楚说明个股风险",
  "Review cash flow, debt, revenue, and price volatility. The analysis shows the figures behind each finding and calls out missing data.": "查看现金流、债务、营收和价格波动。分析会展示每项结果对应的数据，并明确指出缺失信息。",
  "Browse ideas, review a stock, save it, then track the position with assignment-risk alerts and rolling suggestions. Web and iOS stay in sync.": "浏览机会、分析个股并保存，再通过被行权风险提醒和转仓建议跟踪持仓。网页端与 iOS 保持同步。",
  "Review cash flow, debt, revenue, and price volatility for any symbol. The result shows risks found by the checks and which data was available.": "查看任意标的的现金流、债务、营收和价格波动。结果会显示检查发现的风险和可用的数据。",
  "Review cash flow, debt, revenue, and price volatility.": "查看现金流、债务、营收和价格波动。",
  "Each check shows its result and the figure behind it.": "每项检查都会显示结果和对应数据。",
  "The analysis flags risks and identifies data it could not check.": "分析会标出风险，并说明哪些数据无法检查。",
  "Pro adds insider history, peer comparison, and a volatility band.": "Pro 增加内部人历史、同业对比和波动区间。",
  "Insider history, peer comparison, and volatility band included.": "包含内部人历史、同业对比和波动区间。",
  "Clear, rule-based findings": "清晰的规则分析结果",
  "Shows risks found and unavailable data. A result with no major issues applies only to the completed checks; it is not a forecast or valuation.": "显示已发现的风险和缺失数据。“未发现明显问题”仅适用于已完成的检查，不代表预测或估值。",
  "No major issues found · 6/6 checks": "未发现明显问题 · 已完成 6/6 项检查",
  "The findings come from fixed checks of available financial and market data. A model may explain the result in plain language, but it does not decide the outcome.": "分析结果来自对可用财务和市场数据的固定规则检查。模型可以用通俗语言解释结果，但不会决定分析结果。",
  "Review cash flow, debt, revenue, and price volatility. Pro adds insider history, peer comparison, and a volatility band.": "查看现金流、债务、营收和价格波动。Pro 增加内部人历史、同业对比和波动区间。",
  "Review cash flow, debt, revenue, and price volatility. The result identifies risks found and data that could not be checked.": "查看现金流、债务、营收和价格波动。结果会列出发现的风险和无法检查的数据。",
  "Read from filed financial statements, not options-chain data.": "读的是申报财务报表，不是期权链数据。",
  "Risk flagged": "发现风险",
  "Needs a closer look": "需要进一步了解",
  "No major issues found": "未发现明显问题",
  "Not enough data": "数据不足",
  "Analysis complete": "分析完成",
  "RISK FLAGGED": "发现风险",
  "CLOSER LOOK": "需要进一步了解",
  "WITHIN RANGE": "处于参考范围",
  "NOT ENOUGH DATA": "数据不足",
  "DATA COVERAGE": "数据覆盖",
  "checks available": "项检查有可用数据",
  "Later checks were not performed after a risk was flagged, so those questions remain open.": "发现风险后，后续检查未继续执行，因此这些问题仍待确认。",
  "This result covers only the checks performed with available data. It does not value the company or recommend buying or selling the stock.": "本结果仅涵盖基于可用数据完成的检查，不代表公司估值，也不构成买入或卖出建议。",
  "Reviewing available financial and market data...": "正在查看可用的财务和市场数据……",
  "Stock Analysis": "个股分析",
  "STOCK ANALYSIS": "个股分析",
  "Run analysis": "开始分析",
}
